/**
 * Tájegység   * SOPRON - Sopron   * NAGY_SOMLO - Nagy-Somló   * ZALA - Zala   * BALATON_FELVIDEK - Balaton-felvidék   * BADACSONY - Badacsony   * BALATONFURED_CSOPAK - Balatonfüred-Csopak   * BALATONBOGLAR - Balatonboglár   * PANNONHALMA - Pannonhalma   * MOR - Mór   * ETYEK_BUDA - Etyek-Buda   * NESZMELY - Neszmély   * TOLNA - Tolna   * SZEKSZARD - Szekszárd   * PECS - Pécs   * VILLANY - Villány   * HAJOS_BAJA - Hajós-Baja   * KUNSAG - Kunság   * CSONGRAD - Csongrád   * MATRA - Mátra   * EGER - Eger   * BUKK - Bükk   * TOKAJ - Tokaj   * CSOPAK - Csopak   * DUNA - Duna   * KALI - Káli   * MONOR - Monor   * PANNON - Pannon   * SOLTVADKERTI - Soltvadkerti   * SOMLO - Somló   * TIHANY - Tihany   * BALATON - Balaton   * NEXT_TO_BALATON - Balaton-melléki   * BETWEEN_DANUBE_AND_TISZA - Duna-Tisza közi   * TRANSDANUBIA - Dunántúl   * UPPER_HUNGARY - Felső-Magyarország   * ZEMPLEN - Zemplén
 */
export type WineLandscapeUnitHun =
  | 'SOPRON'
  | 'NAGY_SOMLO'
  | 'ZALA'
  | 'BALATON_FELVIDEK'
  | 'BADACSONY'
  | 'BALATONFURED_CSOPAK'
  | 'BALATONBOGLAR'
  | 'PANNONHALMA'
  | 'MOR'
  | 'ETYEK_BUDA'
  | 'NESZMELY'
  | 'TOLNA'
  | 'SZEKSZARD'
  | 'PECS'
  | 'VILLANY'
  | 'HAJOS_BAJA'
  | 'KUNSAG'
  | 'CSONGRAD'
  | 'MATRA'
  | 'EGER'
  | 'BUKK'
  | 'TOKAJ'
  | 'CSOPAK'
  | 'DUNA'
  | 'KALI'
  | 'MONOR'
  | 'PANNON'
  | 'SOLTVADKERTI'
  | 'SOMLO'
  | 'TIHANY'
  | 'BALATON'
  | 'NEXT_TO_BALATON'
  | 'BETWEEN_DANUBE_AND_TISZA'
  | 'TRANSDANUBIA'
  | 'UPPER_HUNGARY'
  | 'ZEMPLEN';

export const WineLandscapeUnitHun = {
  Sopron: 'SOPRON' as WineLandscapeUnitHun,
  NagySomlo: 'NAGY_SOMLO' as WineLandscapeUnitHun,
  Zala: 'ZALA' as WineLandscapeUnitHun,
  BalatonFelvidek: 'BALATON_FELVIDEK' as WineLandscapeUnitHun,
  Badacsony: 'BADACSONY' as WineLandscapeUnitHun,
  BalatonfuredCsopak: 'BALATONFURED_CSOPAK' as WineLandscapeUnitHun,
  Balatonboglar: 'BALATONBOGLAR' as WineLandscapeUnitHun,
  Pannonhalma: 'PANNONHALMA' as WineLandscapeUnitHun,
  Mor: 'MOR' as WineLandscapeUnitHun,
  EtyekBuda: 'ETYEK_BUDA' as WineLandscapeUnitHun,
  Neszmely: 'NESZMELY' as WineLandscapeUnitHun,
  Tolna: 'TOLNA' as WineLandscapeUnitHun,
  Szekszard: 'SZEKSZARD' as WineLandscapeUnitHun,
  Pecs: 'PECS' as WineLandscapeUnitHun,
  Villany: 'VILLANY' as WineLandscapeUnitHun,
  HajosBaja: 'HAJOS_BAJA' as WineLandscapeUnitHun,
  Kunsag: 'KUNSAG' as WineLandscapeUnitHun,
  Csongrad: 'CSONGRAD' as WineLandscapeUnitHun,
  Matra: 'MATRA' as WineLandscapeUnitHun,
  Eger: 'EGER' as WineLandscapeUnitHun,
  Bukk: 'BUKK' as WineLandscapeUnitHun,
  Tokaj: 'TOKAJ' as WineLandscapeUnitHun,
  Csopak: 'CSOPAK' as WineLandscapeUnitHun,
  Duna: 'DUNA' as WineLandscapeUnitHun,
  Kali: 'KALI' as WineLandscapeUnitHun,
  Monor: 'MONOR' as WineLandscapeUnitHun,
  Pannon: 'PANNON' as WineLandscapeUnitHun,
  Soltvadkerti: 'SOLTVADKERTI' as WineLandscapeUnitHun,
  Somlo: 'SOMLO' as WineLandscapeUnitHun,
  Tihany: 'TIHANY' as WineLandscapeUnitHun,
  Balaton: 'BALATON' as WineLandscapeUnitHun,
  NextToBalaton: 'NEXT_TO_BALATON' as WineLandscapeUnitHun,
  BetweenDanubeAndTisza: 'BETWEEN_DANUBE_AND_TISZA' as WineLandscapeUnitHun,
  Transdanubia: 'TRANSDANUBIA' as WineLandscapeUnitHun,
  UpperHungary: 'UPPER_HUNGARY' as WineLandscapeUnitHun,
  Zemplen: 'ZEMPLEN' as WineLandscapeUnitHun,
};
